import axios, { AxiosResponse } from 'axios'
import httpService from '../httpService'
import { Profile } from '../types/Profile'

export function getStates(): Promise<AxiosResponse<Profile.State[]>> {
  return httpService.get(`/v7/content/sources/states/`)
}

export function getRoles(): Promise<AxiosResponse<Profile.Role[]>> {
  return httpService.get(`/v7/content/sources/roles/`)
}

export function getQualifications(): Promise<AxiosResponse<Profile.Qualification[]>> {
  return httpService.get(`/v7/content/sources/qualifications/`)
}

export function getStaffProfiles(
  filter: Profile.Filter,
): Promise<AxiosResponse<Profile.ProfileListResponse>> {
  return httpService.get(`/v7/content/sources/staffs/`, {
    params: filter,
    // Added this to pass each array elements as params as query params by & separated
    paramsSerializer: params => {
      const queryParams = new URLSearchParams();
      Object.entries(params).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach(val => queryParams.append(key, String(val)));
        } else if (value !== undefined) {
          queryParams.append(key, String(value));
        }
      });

      return queryParams.toString();
    }
  })
}

export function searchUserProfiles(phone: string): Promise<AxiosResponse<Profile.User>> {
  return httpService.get(`/v7/content/sources/staffs/search/`, {
    params: {
      phone,
    },
  })
}

export function getProfile(profileId: number): Promise<AxiosResponse<Profile.User>> {
  return httpService.get(`/v7/content/sources/staffs/${profileId}/`)
}

// POST api/v7/content/sources/staffs/

// Update Staff
// PUT api/v7/content/sources/staffs/<user_id>/

export function createProfile(
  profileDetails: Omit<Profile.User, 'id'>,
): Promise<AxiosResponse<Profile.User>> {
  return httpService.post(`/v7/content/sources/staffs/`, profileDetails)
}

export function updateProfile(
  profileId: number,
  profileDetails: Omit<Profile.User, 'id'>,
): Promise<AxiosResponse<Profile.User>> {
  return httpService.put(`/v7/content/sources/staffs/${profileId}/`, profileDetails)
}

export function resetTotp(staffId: number): Promise<AxiosResponse> {
  return httpService.post(`/v7/content/sources/staffs/${staffId}/reset-totp/`)
}

export function getUploadUrl(
  fileType: string,
  extension: string,
): Promise<AxiosResponse<Profile.UploadUrlResponse>> {
  return httpService.get(`/v7/content/sources/staffs/get-upload-url/`, {
    params: { fileType, extension },
  })
}

export async function uploadToS3(
  uploadData: Profile.UploadUrlResponse['uploadData'],
  file: File,
  onUploadProgress?: (event: ProgressEvent) => void,
): Promise<void> {
  const formData = new FormData()
  Object.entries(uploadData.fields).forEach(([key, value]) => {
    formData.append(key, value)
  })
  // file must be appended last for presigned POST to work
  formData.append('file', file)
  await axios.post(uploadData.url, formData, {
    onUploadProgress,
    timeout: 120_000,
  })
}
